module.exports = __webpack_public_path__ + "img/Dinamo-Zagreb.7d5486d5.png";